import React from "react";
import PropTypes from "prop-types";
import RealPaypalButton from "components/payments/PaypalButton";
import StripeForm from "components/payments/StripeForm";
import {
  paypalHandlersPropTypes,
  stripeHandlersPropTypes
} from "components/payments/propTypes";

export default function FullPaymentForm(props) {
  const {
    paypalEnvironment,
    paypalProcessing,
    paypalHandlers,
    stripeReturnUrl,
    FormButtons,
    stripeHandlers,
    stripeProcessing,
    disabled,
    paypalErrorMessage,
    stripeErrorMessage,
    stripeFormKey,
    PaypalButton,
    StripePaymentElement,
    subscriptionType,
    clientSecret,
    isPaymentIntent
  } = props;
  return (
    <div className="payment-form">
      <PaypalButton
        environment={paypalEnvironment}
        processing={paypalProcessing}
        disabled={disabled}
        errorMessage={paypalErrorMessage}
        {...paypalHandlers}
      />
      <StripeForm
        isPaymentIntent={isPaymentIntent}
        clientSecret={clientSecret}
        stripeFormKey={stripeFormKey}
        returnUrl={stripeReturnUrl}
        FormButtons={FormButtons}
        processing={stripeProcessing}
        disabled={disabled}
        errorMessage={stripeErrorMessage}
        StripePaymentElement={StripePaymentElement}
        subscriptionType={subscriptionType}
        {...stripeHandlers}
      />
    </div>
  );
}

FullPaymentForm.propTypes = {
  FormButtons: PropTypes.element,
  PaypalButton: PropTypes.elementType,
  StripePaymentElement: PropTypes.elementType,
  clientSecret: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  isPaymentIntent: PropTypes.bool,
  paypalEnvironment: PropTypes.oneOf(["live", "sandbox"]).isRequired,
  paypalErrorMessage: PropTypes.string,
  paypalHandlers: PropTypes.shape(paypalHandlersPropTypes).isRequired,
  paypalProcessing: PropTypes.bool.isRequired,
  stripeErrorMessage: PropTypes.string,
  stripeFormKey: PropTypes.string,
  stripeHandlers: PropTypes.shape(stripeHandlersPropTypes).isRequired,
  stripeProcessing: PropTypes.bool.isRequired,
  stripeReturnUrl: PropTypes.string,
  subscriptionType: PropTypes.string.isRequired
};

FullPaymentForm.defaultProps = {
  FormButtons: null,
  PaypalButton: RealPaypalButton,
  StripePaymentElement: undefined,
  isPaymentIntent: false,
  paypalErrorMessage: null,
  stripeErrorMessage: null,
  stripeFormKey: null
};
